module.exports = __webpack_public_path__ + "img/lc1.f077c4ab.png";